import { Configuration } from "@/apiGenerate/authentication/runtime";

export const authenticationApiConfig = new Configuration({
    basePath: process.env.VUE_APP_AUTHENTICATION_BASE_URL,
});
